import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}


export const generateVideoThumbnail = (file): Promise<string> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // מניעת דליפות זיכרון - יצירת URL רק פעם אחת
    video.src = URL.createObjectURL(file);
    video.crossOrigin = "anonymous";
    video.muted = true;
    video.playsInline = true;

    // הפעולה הראשונה: טעינת מטא-דאטה של הווידאו כדי לדעת את הגודל המקורי
    video.onloadedmetadata = () => {
      // הגדרת רוחב מקסימלי רצוי ל-Thumbnail (למשל 300)
      const maxWidth = 300; 
      
      // חישוב יחס הגובה-רוחב (Aspect Ratio) של הווידאו
      const aspectRatio = video.videoHeight / video.videoWidth;
      
      // קביעת הרוחב של ה-Canvas (או הגודל המקורי או ה-maxWidth)
      canvas.width = Math.min(maxWidth, video.videoWidth);
      
      // קביעת הגובה של ה-Canvas בהתאם ליחס הגובה-רוחב
      canvas.height = canvas.width * aspectRatio;

      // רק עכשיו, אחרי שיש לנו את המידות, אפשר לקפוץ לזמן הרצוי
      video.currentTime = 1; // קח פריים בשנייה 1
    };

    // הפעולה השנייה: אחרי שקפצנו לזמן המבוקש והפריים מוכן לציור
    video.onseeked = () => {
      // בודקים שה-Context של ה-Canvas קיים
      if (!ctx) {
        reject(new Error("Failed to get canvas context"));
        URL.revokeObjectURL(video.src); // ניקוי גם במקרה של שגיאה
        return;
      }

      // הציור: מציירים את פריים הווידאו על כל שטח ה-Canvas
      // (התמונה "תימתח" או "תתכווץ" בדיוק לגודל של ה-Canvas שהגדרנו)
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // המרה ל-Base64 בפורמט JPEG, עם איכות של 70%
      const image = canvas.toDataURL("image/jpeg", 0.7);

      resolve(image);

      // ניקוי זיכרון חובה!
      URL.revokeObjectURL(video.src);
    };

    // טיפול בשגיאות
    video.onerror = (err) => {
      reject(new Error("Video loading error: " + err));
      URL.revokeObjectURL(video.src);
    };
  });
};

// export const generateVideoThumbnail = (file):
//   Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const video = document.createElement("video");
//     const canvas = document.createElement("canvas");
//     const ctx = canvas.getContext("2d");

//     video.src = URL.createObjectURL(file);
//     video.crossOrigin = "anonymous";
//     video.muted = true;
//     video.playsInline = true;

//     // ברגע שהוידאו נטען
//     video.onloadeddata = () => {
//       // קח פריים בשנייה 1 (אפשר לשנות)
//       video.currentTime = 1;
//     };

//     video.onseeked = () => {
//       canvas.width = video.videoWidth;
//       canvas.height = video.videoHeight;

//       ctx.drawImage(video, 0, 0, 300, 300 * (video.videoHeight / video.videoWidth)); // שמור על יחס הגובה-רוחב

//       const image = canvas.toDataURL("image/png",0.7);

//       resolve(image);

//       URL.revokeObjectURL(video.src);
//     };

//     video.onerror = (err) => reject(err);
//   });
// };